import { useEffect } from "react";
import { Box, Button, Modal, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { English } from "../../constant/EnglishFallback";
/*
Warning message popup component with a "Go Back" button. Two optional buttons, a red and blue
button, can be added if the text and onClick function are defined.

PromptModal code in parent must be under any other modals in order to appear on top

Props (* required):
  *isOpen				- boolean; modal visibility variable
  *onClose			- function; to modify visibility state variable
  *title				- string; prompt title
  *desc				- string; prompt description
  redButtonText		- string; red button text
  onRedButtonClick	- function; executed on red button click
  blueButtonText		- string; blue button text
  onBlueButtonClick	- function; executed on blue button click

Usage:
  <PromptModal
    isOpen={}
    onClose={() => }
    heading=""
    title=""
    desc=""
    redButtonText=""
    onRedButtonClick={() => }
    />
*/
function PromptModal(props) {
  const { multiLanguageData } = useSelector((state) => state?.main);
  const { BUTTON_MODAL_DELETE_NO = English?.Profile?.BUTTON_MODAL_DELETE_NO } =
    multiLanguageData?.Profile || {};

  useEffect(() => {
    if (props.isLoading == false) {
      props.onClose();
    }
  }, [props.isLoading]);

  return (
    <>
      <Modal open={props.isOpen} onClose={props.onClose}>
        <Box className="user-modal-responsive">
          {props.heading &&
          (
            <div style={{ paddingBottom: "10px" }}>
              <Typography variant="h4" fontWeight={"bold"}>
                {props.heading}
              </Typography>
            </div>
          )}
          <div style={{ paddingBottom: "15px" }}>
            <Typography variant="h5">{props.title}</Typography>
            <Typography variant="subtitle1">{props.desc}</Typography>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            {!props.blueButtonText && !props.onBlueButtonClick && (
              <Button
                variant={props?.clientActionButtonText ? "contained" : "outlined"}
                onClick={props.onClose}
                style={
                  props?.clientActionButtonText
                    ? {
                        backgroundColor: "GrayText"
                      }
                    : {}
                }>
                <b>{BUTTON_MODAL_DELETE_NO}</b>
              </Button>
            )}

            <div>
              {
                // If blueButtonText and onBlueButtonClick is defined, show the blue button
                props.blueButtonText2 && props.onBlueButtonClick2 ? (
                  <Button
                    variant="contained"
                    onClick={props.onBlueButtonClick2}
                    style={{
                      marginRight: "10px",
                      backgroundColor: "#0826b8"
                    }}>
                    <b>{props.blueButtonText2}</b>
                  </Button>
                ) : (
                  <></>
                )
              }
              {
                // If blueButtonText and onBlueButtonClick is defined, show the blue button
                props.blueButtonText && props.onBlueButtonClick ? (
                  <Button
                    variant="contained"
                    onClick={props.onBlueButtonClick}
                    style={{
                      marginRight: "10px",
                      backgroundColor: "#0826b8"
                    }}>
                    <b>{props.blueButtonText}</b>
                  </Button>
                ) : (
                  <></>
                )
              }
              {
                // If redButtonText and onRedButtonClick is defined, show the red button
                props.redButtonText && props.onRedButtonClick ? (
                  <Button
                    loading={props?.isLoading}
                    variant="contained"
                    color="error"
                    onClick={props.onRedButtonClick}>
                    <b>{props.redButtonText}</b>
                  </Button>
                ) : (
                  <></>
                )
              }

              {props.clientActionButtonClick && props.clientActionButtonText ? (
                <Button
                  variant="contained"
                  color="error"
                  style={{ backgroundColor: props?.clientAccentColor }}
                  onClick={props.clientActionButtonClick}>
                  <b>{props.clientActionButtonText}</b>
                </Button>
              ) : (
                <></>
              )}
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
}

export default PromptModal;
